import { render, staticRenderFns } from "./DocumentDownload.vue?vue&type=template&id=70b8e592&scoped=true&"
import script from "./DocumentDownload.vue?vue&type=script&lang=js&"
export * from "./DocumentDownload.vue?vue&type=script&lang=js&"
import style0 from "./DocumentDownload.vue?vue&type=style&index=0&id=70b8e592&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b8e592",
  null
  
)

export default component.exports